(function () {
  // Barra de anuncios rotativa
  document.querySelectorAll('[data-rotator]').forEach(function (track) {
    var items = track.children;
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  });

  // Menú móvil
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // Formato de dinero (COP)
  function formatMoney(cents) {
    var format = window.shopMoneyFormat || '${{amount_no_decimals}}';
    var value = (cents / 100);
    var noDec = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withDec = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key.indexOf('no_decimals') > -1) return noDec;
      if (key.indexOf('comma') > -1) return withDec;
      return value.toFixed(2);
    });
  }

  // Botones "Pedir ahora" de secciones intermedias: suben al formulario
  document.querySelectorAll('[data-scroll-buy]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var f = document.getElementById('product-form');
      if (f) { e.preventDefault(); f.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  });

  var product = document.querySelector('[data-product]');
  if (!product) return;

  // Galería
  var main = product.querySelector('[data-main-media] img');
  product.querySelectorAll('[data-thumb]').forEach(function (btn, idx) {
    if (idx === 0) btn.classList.add('is-active');
    btn.addEventListener('click', function () {
      if (main) { main.src = btn.dataset.thumb; main.removeAttribute('srcset'); }
      product.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Variantes
  var variantsEl = product.querySelector('[data-variants]');
  var idInput = product.querySelector('[data-variant-id]');
  var buyBtn = product.querySelector('[data-buy-button]');
  var buyLabel = buyBtn ? buyBtn.textContent : '';
  var currentPrice = null;

  function updateBundles(price) {
    product.querySelectorAll('[data-bundle-qty]').forEach(function (el) {
      el.textContent = formatMoney(price * parseInt(el.dataset.bundleQty, 10));
    });
  }

  if (variantsEl && idInput) {
    var variants = JSON.parse(variantsEl.textContent);
    product.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        product.querySelectorAll('[data-option-index]:checked').forEach(function (c) {
          selected[parseInt(c.dataset.optionIndex, 10)] = c.value;
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        currentPrice = match.price;
        var priceEl = product.querySelector('.price__current');
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        updateBundles(match.price);
        if (buyBtn) {
          buyBtn.disabled = !match.available;
          buyBtn.textContent = match.available ? buyLabel : 'Agotado';
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      });
    });
  }

  // Barra fija en móvil
  var sticky = document.querySelector('[data-sticky-buy]');
  var form = document.getElementById('product-form');
  if (sticky && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(form);
    var trigger = sticky.querySelector('[data-sticky-trigger]');
    trigger.addEventListener('click', function () {
      var codApp = document.querySelector('[data-cod-trigger], .releasit-button, #_rsi-cod-form-button, .es-form-button');
      if (codApp) { codApp.click(); return; }
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
  }
})();
